import { __decorate } from "tslib";
import { trimAll } from '../util';
import { Vue, Component, Prop, Watch, Model } from 'vue-property-decorator';
import CommonApi from './api';
import { local } from './storage';
import Checkbox from '../checkbox';
import { LoginErrorType, LoginErrorMessage } from './types';
const style = require('./index.module.scss');
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        // 是否正在登录中：当用户点击登录且结果未返回时，应禁止再次点击
        this.isLogging = false;
        // 手机号
        this.phoneNum = '';
        // 手机号错误提示文案
        this.phoneErr = '请输入正确的手机号';
        // 手机号格式错误信息显示
        this.phoneNumValidator = false;
        // 验证码
        this.smsNum = '';
        // 验证码错误提示
        this.smsErr = '请输入正确的验证码';
        // 验证码错误提示文案
        this.smsNumValidator = false;
        // 验证码发送成功 时间戳
        this.sendTime = 0;
        // 获取验证码按钮是否点击过
        this.isSmsHasClick = false;
        // 验证码是否聚焦
        this.isSmsFocus = false;
        // 手机号输入框是否聚焦
        this.isPhoneNumFocus = false;
        // 在清空图标mousedown事件标记（blur事件会优先与clearIcon.click事件发生，导致clearIcon.click无法被触发）
        this.isSmsClearIconClick = false;
        // 在清空图标mousedown事件标记（blur事件会优先与clearIcon.click事件发生，导致clearIcon.click无法被触发）
        this.isPhoneNumClearIconClick = false;
        // 验证码倒计时timer
        this.countInterval = null;
    }
    // 是否显示验证码清除图标
    get showSmsClear() {
        return this.showSmsClearBtn && this.isSmsFocus && !!this.smsNum;
    }
    // 是否显示手机号清除图标
    get showPhoneClear() {
        return this.isPhoneNumFocus && !!this.phoneNum;
    }
    // 手机号不为空
    get phoneNumReady() {
        return this.phoneNum.length !== 0;
    }
    // 验证码位数不为0
    get smsNumReady() {
        return this.smsNum.length !== 0;
    }
    // 校验手机号格式
    isPhoneNumValidator() {
        const regResult = trimAll(this.phoneNum).match(/^1\d{10}$/);
        if (regResult) {
            this.phoneNumValidator = false;
        }
        else {
            this.phoneNumValidator = true;
        }
        return regResult;
    }
    // 手机号输入校验通过 验证码按钮可以点击
    smsBtnReady() {
        if (this.isCountingDown()) {
            return false;
        }
        // return this.phoneNum.length !== 0 && this.phoneNumValidator === false
        return this.phoneNum.length !== 0;
    }
    // 校验验证码
    isSmsNumValidator() {
        const regResult = trimAll(this.smsNum).match(/^\d{4}$/);
        if (regResult) {
            this.smsNumValidator = false;
        }
        else {
            this.smsNumValidator = true;
        }
        return regResult;
    }
    // 手机号校验错误重置
    validatePhoneNumReset() {
        this.phoneNumValidator = false;
        this.$emit('phoneNumClick');
    }
    // 验证码校验错误重置
    validateSmsNumReset() {
        this.smsNumValidator = false;
        this.$emit('smsNumClick');
    }
    // 验证码输入框 focus
    smsFocus() {
        this.isSmsFocus = true;
    }
    // 验证码输入框 blur
    smsBlur() {
        if (!this.isSmsClearIconClick) {
            this.isSmsFocus = false;
        }
    }
    smsMarkTryClearInputField() {
        this.isSmsClearIconClick = true;
    }
    // 手机号输入框 focus
    phoneNumFocus() {
        this.isPhoneNumFocus = true;
    }
    // 手机号输入框 blur
    phoneNumBlur() {
        if (!this.isPhoneNumClearIconClick) {
            this.isPhoneNumFocus = false;
        }
    }
    phoneNumMarkTryClearInputField() {
        this.isPhoneNumClearIconClick = true;
    }
    onSendTimeChange() {
        if (this.isCountingDown()) {
            this.startCountDown();
        }
    }
    // 清空验证码按钮点击
    onClearSmsField() {
        this.isSmsClearIconClick = false;
        this.isSmsFocus = false;
        if (this.smsRef) {
            this.smsRef.focus();
        }
        this.smsNum = '';
    }
    // 验证码dom节点
    get smsRef() {
        if (this.$refs.smsRef) {
            return this.$refs.smsRef;
        }
        return null;
    }
    // 清空手机号按钮点击
    onClearPhoneNumField() {
        this.isPhoneNumClearIconClick = false;
        this.isPhoneNumFocus = false;
        if (this.phoneNumRef) {
            this.phoneNumRef.focus();
        }
        this.phoneNum = '';
    }
    // 手机号dom节点
    get phoneNumRef() {
        if (this.$refs.phoneNumRef) {
            return this.$refs.phoneNumRef;
        }
        return null;
    }
    // 获取发送时间到当前时刻的时长
    getSeconds() {
        return Math.floor((new Date().getTime() - this.sendTime) / 1000);
    }
    // 倒计时
    getCountSeconds() {
        return Math.max(0, this.duration - this.getSeconds());
    }
    // 当前是否处于倒计时状态
    isCountingDown() {
        return this.getSeconds() < this.duration;
    }
    beforeDestroy() {
        this.resetCountDown();
    }
    // 登录成功回调
    loginCb() {
        this.$emit('loginCb');
    }
    // 登录成功不设置用户信息
    loginCbWithOutInfo(originUserInfo) {
        this.$emit('loginCbWithOutInfo', originUserInfo);
    }
    // 开始倒计时
    startCountDown() {
        if (!this.isSmsHasClick) {
            this.isSmsHasClick = true;
        }
        const buttonRef = this.$refs.button;
        if (buttonRef && !this.countInterval && this.isCountingDown()) {
            buttonRef.innerText = this.getCountDownText(this.getCountSeconds());
            this.countInterval = setInterval(() => {
                const countSeconds = this.getCountSeconds();
                const isCountingDown = this.isCountingDown();
                const countDownText = this.getCountDownText(countSeconds);
                if (countSeconds <= 0) {
                    this.resetCountDown(true);
                }
                buttonRef.innerText = isCountingDown ? countDownText : (this.isSmsHasClick ? this.reSendLabelText : this.labelText);
            }, 1000);
        }
    }
    // 重置倒计时
    resetCountDown(shouldRerender = false) {
        if (this.countInterval) {
            clearInterval(this.countInterval);
            this.countInterval = null;
            Vue.nextTick(() => {
                shouldRerender && this.$forceUpdate();
            });
        }
    }
    // 获取验证码
    onButtonClick() {
        if (this.smsBtnReady()) {
            // 手机号校验通过 执行获取验证码逻辑
            if (this.isPhoneNumValidator()) {
                if (!this.isCountingDown()) {
                    this.sendTime = new Date().getTime();
                    this.sendSmsNum();
                }
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    // 登录
    async onSubmit() {
        // 当用户正在登录中时，应禁止再次点击
        if (this.isLogging) {
            return false;
        }
        // 登录按钮点击事件外传
        this.$emit('loginBtnClickEvent');
        // 手机号没填
        if (!this.phoneNumReady) {
            this.loginErrorCallBack({
                type: LoginErrorType.EmptyPhoneNum,
                message: LoginErrorMessage.EmptyPhoneNum
            });
            return false;
        }
        // 手机号校验失败
        if (!this.isPhoneNumValidator()) {
            this.loginErrorCallBack({
                type: LoginErrorType.InvalidPhoneNum,
                message: LoginErrorMessage.InvalidPhoneNum
            });
            return false;
        }
        // 验证码没填
        if (!this.smsNumReady) {
            this.loginErrorCallBack({
                type: LoginErrorType.EmptySmsNum,
                message: LoginErrorMessage.EmptySmsNum
            });
            return false;
        }
        // 验证码校验失败
        if (!this.isSmsNumValidator()) {
            this.loginErrorCallBack({
                type: LoginErrorType.InvalidSmsNum,
                message: LoginErrorMessage.InvalidSmsNum
            });
            return false;
        }
        // 协议未勾选
        if (this.contracts.length && !this.contractsChecked) {
            this.loginErrorCallBack({
                type: LoginErrorType.ContractsUnchecked,
                message: LoginErrorMessage.ContractsUnchecked
            });
            return false;
        }
        // 发起登录请求前，将正在登录中标记为true
        this.isLogging = true;
        try {
            const originUserInfo = await CommonApi.login(this.phoneNum, this.smsNum);
            const { token } = originUserInfo;
            if (this.setUser) {
                if (token) {
                    const financeUser = await CommonApi.getFinanceUser(token, undefined);
                    local.set(this.LocalEnumFinanceUser, { hellobike: originUserInfo, finance: financeUser }, financeUser.expiresIn);
                    // 执行登录成功逻辑
                    this.loginCb();
                }
            }
            else {
                this.loginCbWithOutInfo(originUserInfo);
            }
            this.isLogging = false;
        }
        catch (error) {
            this.loginErrorCallBack({
                type: LoginErrorType.LoginRequestError,
                message: error.message
            });
            this.isLogging = false;
        }
    }
    // 获取验证码
    async sendSmsNum() {
        try {
            this.$emit('sendSmsMsg');
            const result = await CommonApi.getLoginCode(this.phoneNum);
        }
        catch (error) {
            this.loginErrorCallBack({
                type: LoginErrorType.SendSmsMsgRequestError,
                message: error.message
            });
        }
    }
    render() {
        const isCountingDown = this.isCountingDown();
        const countSeconds = this.getCountSeconds();
        const countDownText = this.getCountDownText(countSeconds);
        const smsBtnReady = this.smsBtnReady();
        const isTitleImg = /^http(s?):\/\//.test(this.title);
        const isCustomTopImg = this.topImgUrl !== undefined;
        return (<div class={[
            style.container,
            this.mainClassName
        ]} style={{
            backgroundImage: isCustomTopImg && `url('${this.topImgUrl}')`,
            backgroundColor: this.mainBgColor
        }}>
        <div class={[style.login, isCustomTopImg && style.loginForCustomTop]}>
          {isTitleImg
            ? <img class={style.titleImg} src={this.title}/>
            : <div class={style.title}>{this.title}</div>}
          <div class={[
            style.rights,
            this.rightImgUrl && style.rightsForCustom,
            this.rightsClassName
        ]} style={{
            backgroundImage: this.rightImgUrl && `url('${this.rightImgUrl}')`
        }}></div>
          <div class={style.formContent}>
            <div class={[style.formItem, this.phoneNumValidator && style.formWithErr]}>
              <div class={style.inputArea}>
                <div class={style.labelContent}>
                  <label for="phone">手机号</label>
                </div>
                <div class={style.inputContent}>
                  <div class={style.inputFiledContent}>
                    <input type="tel" maxlength="11" placeholder="请输入领取手机号" name="phone" id="phone" v-model={this.phoneNum} onBlur={this.phoneNumBlur} onClick={this.validatePhoneNumReset} onFocus={this.phoneNumFocus} ref="phoneNumRef"/>
                    <div class={style.errMsg} v-show={this.phoneNumValidator}>
                      <span class={style.errImg}></span>
                      <span>{this.phoneErr}</span>
                    </div>
                  </div>
                  {this.showPhoneClear &&
            <div class={style.clearIcon} onClick={this.onClearPhoneNumField} onMousedown={this.phoneNumMarkTryClearInputField}></div>}
                </div>
              </div>
            </div>
            <div class={[style.formItem, this.smsNumValidator && style.formWithErr]}>
              <div class={style.inputArea}>
                <div class={style.labelContent}>
                  <label for="captcha">验证码</label>
                </div>
                <div class={style.inputContent}>
                  <div class={style.inputFiledContent}>
                    <input type="tel" maxlength="4" placeholder="请输入验证码" name="captcha" id="captcha" v-model={this.smsNum} onBlur={this.smsBlur} onClick={this.validateSmsNumReset} onFocus={this.smsFocus} ref="smsRef"/>
                    <div class={style.errMsg} v-show={this.smsNumValidator}>
                      <span class={style.errImg}></span>
                      <span>{this.smsErr}</span>
                    </div>
                  </div>
                  {this.showSmsClear &&
            <div class={style.clearIcon} onClick={this.onClearSmsField} onMousedown={this.smsMarkTryClearInputField}></div>}
                  <div class={style.inputRightContent}>
                    <div class={[style.sms, smsBtnReady ? '' : style.disabled, isCountingDown ? style.smsCountDown : '']} ref='button' onClick={this.onButtonClick}>
                      <span>{isCountingDown ? countDownText : (this.isSmsHasClick ? this.reSendLabelText : this.labelText)}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.getContractsContent()}
          <div class={[
            style.loginBtn,
            this.loginClassName
        ]} onClick={this.onSubmit}>{this.submitText}</div>
          {this.remindText.length ? <div class={[
            style.remind,
            this.remindClassName
        ]}>{this.remindText}</div> : null}
        </div>
        {this.showLogo && <div class={style.logo}/>}
      </div>);
    }
    getContractsContent() {
        return this.contracts.length ? (<div class={style.contractsContainer}>
        <Checkbox checked={this.contractsChecked} onChange={(v) => this.$emit('contractCheckedChange', v)}/>
        <div class={style.detail}>
          {this.contractsPrefixText}
          {this.contracts.map((item, index) => (<span key={item} class={style.contractName} onClick={() => this.$emit('contractClick', index, item)}>{item}</span>))}
        </div>
      </div>) : null;
    }
};
__decorate([
    Prop(String)
], Login.prototype, "mainClassName", void 0);
__decorate([
    Prop(String)
], Login.prototype, "topImgUrl", void 0);
__decorate([
    Prop(String)
], Login.prototype, "mainBgColor", void 0);
__decorate([
    Prop(String)
], Login.prototype, "rightsClassName", void 0);
__decorate([
    Prop(String)
], Login.prototype, "rightImgUrl", void 0);
__decorate([
    Prop(String)
], Login.prototype, "loginClassName", void 0);
__decorate([
    Prop(String)
], Login.prototype, "remindClassName", void 0);
__decorate([
    Prop({
        type: String,
        default: 'FinanceUser'
    })
], Login.prototype, "LocalEnumFinanceUser", void 0);
__decorate([
    Prop({
        type: String,
        default: '立即登录 领取福利'
    })
], Login.prototype, "title", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false
    })
], Login.prototype, "showSmsClearBtn", void 0);
__decorate([
    Prop({
        type: String,
        default: '获取验证码'
    })
], Login.prototype, "labelText", void 0);
__decorate([
    Prop({
        type: String,
        default: '重新获取'
    })
], Login.prototype, "reSendLabelText", void 0);
__decorate([
    Prop({
        type: String,
        default: '登录'
    })
], Login.prototype, "submitText", void 0);
__decorate([
    Prop({
        type: String,
        default: ''
    })
], Login.prototype, "remindText", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false
    })
], Login.prototype, "showLogo", void 0);
__decorate([
    Model('change', {
        type: Boolean,
        default: false
    })
], Login.prototype, "contractsChecked", void 0);
__decorate([
    Prop({
        type: String,
        default: '我已阅读并同意'
    })
], Login.prototype, "contractsPrefixText", void 0);
__decorate([
    Prop({
        type: Array,
        default: () => []
    })
], Login.prototype, "contracts", void 0);
__decorate([
    Prop({
        type: Function,
        default: (seconds) => `${seconds}S后重新获取`
    })
], Login.prototype, "getCountDownText", void 0);
__decorate([
    Prop({
        type: Number,
        default: 60
    })
], Login.prototype, "duration", void 0);
__decorate([
    Prop({
        type: Function,
        default: () => { }
    })
], Login.prototype, "loginErrorCallBack", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: true
    })
], Login.prototype, "setUser", void 0);
__decorate([
    Watch('sendTime')
], Login.prototype, "onSendTimeChange", null);
Login = __decorate([
    Component
], Login);
export default Login;
//# sourceMappingURL=index.jsx.map